import { gsap, ScrollTrigger, smoothScrollObj } from "../layout";

// swiper
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
// fancyapps
import { Fancybox } from "@fancyapps/ui";
// matchheight
import matchHeight from 'jquery-match-height';
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

Fancybox.bind('[data-fancybox]', {
    Thumbs: false,
    Toolbar: {
        display: {
            // left: [],
            // middle: [],
            right: ["close"],
        },
    },
    Images : {
        zoom : false
    },
    backdropClick: false
});

function certificationSection() {
    const certificationSwiper = new Swiper(".certification__swiper", {
        modules: [ Pagination, Autoplay ],
        spaceBetween: 30,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".certification__pagination",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 16,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 30,
                loop: false,
            },
        }
    });
}

function messageSectionResponsive() {
    const messageImageCol = document.querySelector('.message__image-col');
    const messageDescriptionCol = document.querySelector('.message__description-col');
    const messageTitle = document.querySelector('.message__title');
    const messageNamePosition = document.querySelector('.message__name-position');

    if (window.innerWidth < 992) {
        messageImageCol.prepend(messageTitle);
        messageDescriptionCol.prepend(messageNamePosition);
    } else {
        messageDescriptionCol.prepend(messageTitle);
        messageDescriptionCol.append(messageNamePosition);
    }
}

function reasonSection() {
    const reasonSwiper = new Swiper(".reason__swiper", {
        modules: [ Navigation ],
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 450,
        allowTouchMove: false,
        navigation: {
            prevEl: ".reason__prev",
            nextEl: ".reason__next",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        }
    });

    $('.reason-card__description').matchHeight();  
}

function boardSection() { 
    $('.board__card').matchHeight();  
}

document.addEventListener('DOMContentLoaded', () => {
    certificationSection();
    messageSectionResponsive();
    reasonSection();
    boardSection();
})

window.addEventListener('resize', () => {
    messageSectionResponsive();
})